export default __webpack_public_path__ + "static/media/element_spec_90.03baa673.webp";